"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsUserInformation = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _AccountCircle = _interopRequireDefault(require("@mui/icons-material/AccountCircle"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _dmsbasereact = require("dmsbasereact");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * @Author: Fernando Schneider
 * @Date:   2023-12-29 22:27:42
 * @Last Modified by:   Fernando Schneider
 * @Last Modified time: 2023-12-30 01:11:26
 */

const DmsUserInformation = () => {
  var _token$login, _token$name;
  const header_text = _reactIntlUniversal.default.get("UserInformation").d("User Information");
  const login_text = _reactIntlUniversal.default.get("Login").d("Login");
  const name_text = _reactIntlUniversal.default.get("Name").d("Name");
  const token = (0, _DmsTokenHook.getToken)();
  const user_login = (_token$login = token === null || token === void 0 ? void 0 : token.login) !== null && _token$login !== void 0 ? _token$login : "-";
  const user_name = (_token$name = token === null || token === void 0 ? void 0 : token.name) !== null && _token$name !== void 0 ? _token$name : "-";
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    color: "inherit",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_AccountCircle.default, null), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    sx: {
      marginLeft: 1
    }
  }, user_login)), /*#__PURE__*/_react.default.createElement(_material.Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    PaperProps: {
      sx: {
        width: 300
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    disabled: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement("strong", null, header_text))), /*#__PURE__*/_react.default.createElement(_material.Divider, null), /*#__PURE__*/_react.default.createElement(_material.MenuItem, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("label", null, name_text, ":"), "\xA0", /*#__PURE__*/_react.default.createElement("span", null, user_name))), /*#__PURE__*/_react.default.createElement(_material.MenuItem, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("label", null, login_text, ":"), "\xA0", /*#__PURE__*/_react.default.createElement("span", null, user_login))), /*#__PURE__*/_react.default.createElement(_material.MenuItem, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsLogout, null))));
};
exports.DmsUserInformation = DmsUserInformation;